import { LocationNumbersService } from '../../../services'

const checkVerification = async function ({ dispatch, state }, payload) {
  const { locationId } = payload
  try {
    const { data } = await LocationNumbersService.getVerificationStatus(payload)

    if (data === 'success') {
      await dispatch('fetchLocationTwilio', locationId)
      await dispatch('fetchCallerIDs', {
        locationId: locationId,
        getPaginatedDataOnly: false,
        payload: {
          limit: state.table?.limit,
          page: state.table?.currentPage,
          query: state.table?.searchText ?? '',
        },
      })
    }

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default checkVerification
